import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ExportBiRun } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  run: ExportBiRun | null;
  retrieveExportBiRun(
    request: Boundaries["retrieveExportBiRun"]["request"],
  ): void;
}

function useRetrieveExportBiRun(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isRetrieveExportBiRunRequestPending),
    isRequestSuccess: useSelector(selector.isRetrieveExportBiRunRequestSuccess),
    isRequestFailure: useSelector(selector.isRetrieveExportBiRunRequestFailure),
    run: useSelector(selector.getExportBiRun),
    retrieveExportBiRun: core.retrieveExportBiRun,
  };
}

export { useRetrieveExportBiRun };
